import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
    return (
        <header className="header">
            <div className="logo"> <Link to="/">Werthan Art Foundation</Link></div>
            <nav className="nav-links">
                <Link to="/">Home</Link>
                <Link to="/Photos">Photos</Link>
                <Link to="/MissionStatement">Mission</Link>
                <Link to="/WerthanArtMuseum">Museum</Link>
                <Link to="/about">About</Link>
                <Link to="/contact">Contact</Link>
            </nav>
        </header>
    );
};

export default Header;
